import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success_circle",
  "use": "icon-success_circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-success_circle\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M17,7.05A7,7,0,1,0,17,17,7,7,0,0,0,17,7.05Zm-5.73,8.43L8,12.3l1.42-1.42,1.77,1.77,3.53-3.54,1.42,1.42Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol